<template lang="pug">
  v-row(no-gutters justify="center") 
    v-col(align="center").pa-5
      v-img(width='80', src='@/assets/anything/checked.svg') 
      h2.green--text.py-5  {{ $t('success-deposit') }} 
      h4.pb-5 {{ $t('waiting-deposit') }}
      v-btn(
        type='submit'
        depressed
        dark
        color='var(--bg-secondary-color)'
        @click='toHomepage()'
      ) {{ $t('button.back-homepage') }}

</template> 
<script>
import { ROUTE_INDEX } from '@/const/route'
export default {
  methods : {
    toHomepage () {
      this.$ga.event('Button', 'BackToHomePage', 'DepositPage','' )
      this.$router.push({
        name:ROUTE_INDEX
      }).catch(()=>{});  
    }
  }
}
</script> 